import { useState } from "react";
import TabsNav from "../../components/TabsNav";
import { ContentStyle } from "../../Theme";
import AllergiesList from "./AllergiesList";

export default function Allergies() { 
    const [showStatus] = useState(true); 
    return (
      <> 
        <TabsNav />
        <ContentStyle>
          <AllergiesList showStatus={showStatus} />
        </ContentStyle>
      </>
    );
}
